
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'no-trial-history',
  templateUrl: './no-trial-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule]
})
export class NoTrialHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}